import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUspsComponent } from './simple-icons-usps.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUspsComponent ],
    exports:      [ SimpleIconsUspsComponent ],
    bootstrap:    []
})
export class SimpleIconsUspsModule {}
